import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProgressionStepsComponent } from '@domgen/dgx-fe-components/progress';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { CheckoutProgressionStepsComponentService } from '../../services/checkout-progression-steps-component/checkout-progression-steps-component.service';
import { translation } from './i18n/translation.constant';

@Component({
  standalone: true,
  selector: 'checkout-progression-steps',
  templateUrl: './checkout-progression-steps.component.html',
  imports: [AsyncPipe, NgIf, ProgressionStepsComponent],
  providers: [
    CheckoutProgressionStepsComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutProgressionStepsComponent {
  constructor(readonly cs: CheckoutProgressionStepsComponentService) {}
}
